import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

interface FirebaseTime {
  seconds?: number
  _seconds?: number
}

export const formattedDate = (firebaseTime: FirebaseTime | null) => {
  const seconds = firebaseTime && (firebaseTime._seconds ?? firebaseTime.seconds)
  return seconds ? dayjs.unix(seconds).utc().format('YYYY-MM-DD HH:mm:ss [UTC]') : ''
}
